// extracted by mini-css-extract-plugin
export var externalLink = "_dx-0";
export var internalLinkLabel = "_dx-1";